export const StyleConverter: Record<string, string> = {
  ['badge-primary']: 'text-bg-primary',
  ['badge-secondary']: 'text-bg-secondary',
  ['badge-info']: 'text-bg-info',
  ['badge-success']: 'text-bg-success',
  ['badge-danger']: 'text-bg-danger',
  ['badge-dark']: 'text-bg-dark',
  ['badge-light']: 'text-bg-light',
  ['badge-inverse']: 'text-bg-inverse',
  ['badge-inprogress']: 'text-bg-inprogress',
  ['badge-noreceipt']: 'text-bg-noreceipt',
  ['badge-pmconfirmed']: 'text-bg-pmconfirmed',
  ['badge-readyforapproval']: 'text-bg-readyforapproval',
};
